var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Uzbekistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00c853",
    d: "M42.325,32H5.675C8.763,39.061,15.801,44,24,44S39.237,39.061,42.325,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M24,4C15.801,4,8.763,8.939,5.675,16h36.649C39.237,8.939,32.199,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M42.716,31H5.284c0.126,0.336,0.248,0.673,0.391,1h36.649C42.468,31.673,42.59,31.336,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M42.325,16H5.675c-0.143,0.327-0.265,0.664-0.391,1h37.431C42.59,16.664,42.468,16.327,42.325,16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19,11.5c0,1.934-1.566,3.5-3.5,3.5S12,13.434,12,11.5S13.566,8,15.5,8S19,9.566,19,11.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M20,11.5c0,1.934-1.566,3.5-3.5,3.5S13,13.434,13,11.5S14.566,8,16.5,8S20,9.566,20,11.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.691,8.617L27,8.383h-0.383L26.5,8l-0.117,0.383H26l0.309,0.234L26.191,9L26.5,8.766L26.809,9 L26.691,8.617z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.691,8.617L30,8.383h-0.383L29.5,8l-0.117,0.383H29l0.309,0.234L29.191,9L29.5,8.766L29.809,9 L29.691,8.617z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.691,8.617L24,8.383h-0.383L23.5,8l-0.117,0.383H23l0.309,0.234L23.191,9L23.5,8.766L23.809,9 L23.691,8.617z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.691,11.617L27,11.383h-0.383L26.5,11l-0.117,0.383H26l0.309,0.234L26.191,12l0.309-0.234 L26.809,12L26.691,11.617z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.691,11.617L30,11.383h-0.383L29.5,11l-0.117,0.383H29l0.309,0.234L29.191,12l0.309-0.234 L29.809,12L29.691,11.617z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.691,11.617L24,11.383h-0.383L23.5,11l-0.117,0.383H23l0.309,0.234L23.191,12l0.309-0.234 L23.809,12L23.691,11.617z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.691,14.617L27,14.383h-0.383L26.5,14l-0.117,0.383H26l0.309,0.234L26.191,15l0.309-0.234 L26.809,15L26.691,14.617z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.691,14.617L30,14.383h-0.383L29.5,14l-0.117,0.383H29l0.309,0.234L29.191,15l0.309-0.234 L29.809,15L29.691,14.617z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.691,14.617L24,14.383h-0.383L23.5,14l-0.117,0.383H23l0.309,0.234L23.191,15l0.309-0.234 L23.809,15L23.691,14.617z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.691,11.617L21,11.383h-0.383L20.5,11l-0.117,0.383H20l0.309,0.234L20.191,12l0.309-0.234 L20.809,12L20.691,11.617z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.691,14.617L21,14.383h-0.383L20.5,14l-0.117,0.383H20l0.309,0.234L20.191,15l0.309-0.234 L20.809,15L20.691,14.617z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.691,14.617L18,14.383h-0.383L17.5,14l-0.117,0.383H17l0.309,0.234L17.191,15l0.309-0.234 L17.809,15L17.691,14.617z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Uzbekistan);
export default __webpack_public_path__ + "static/media/icons8-uzbekistan.a90602f6222f776054102ba7545a4c95.svg";
export { ForwardRef as ReactComponent };